
import { useEffect, useRef, useState } from "react";

import axios from "axios";

/**
 * Hook for Kibana iframe auth: fetches refresh token and sets cookie.
 * @param {string} [organizationIdentifier] - Optional. When provided (client side), uses this org for the token API.
 *   When omitted or falsy (e.g. internal dashboard), defaults to "promptcloud".
 */
export const useKibanaAuthentication = (organizationIdentifier) => {
  const org = organizationIdentifier || "promptcloud";
  const REFRESH_INTERVAL = 15 * 60 * 1000; // 15 minutes in milliseconds

  function setKibanaCookie(src_url) {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = src_url;
      iframe.onload = () => {
        resolve();
      };
      document.body.appendChild(iframe);
    });
  }

  const intervalRef = useRef(null); // stores interval ID

  // Clear interval when component unmounts
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const refreshToken = async (url) => {
    const response  = await axios.get(`/api/v1/organizations/${org}/self_service_dashboard/refresh_token`);
    const data = await response.data;
    const baseUrl = url.replace(/\/$/, "");
    await setKibanaCookie(`${baseUrl}/set-token?refreshToken=${data.refresh_token}`);
  };

  const setToken = async (url) => {
    await refreshToken(url);
    intervalRef.current = setInterval(() => refreshToken(url), REFRESH_INTERVAL);
  };

  return {
    setToken
  };

}